import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import StyledLink from '@makeship/core/lib/components/Link';
import posthog from 'posthog-js';
import { Caption } from '../Typography';

const DisclaimerWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.neutral4};
`;

const ImageWrapper = styled.div`
  display: flex;
  margin: 24px 0px 16px 0px;
  width: 339px;
  height: 127px;
  position: relative;
`;

const TextWrapper = styled.div``;

const DisclaimerText = styled(Caption)``;

const Pride2025Disclaimer: React.FC = () => {
  const modalLocation = 'pdp_view_details';

  return (
    <DisclaimerWrapper>
      <ImageWrapper>
        <Image
          src="/assets/pride2025/PRIDE25_Logo-Lockup_black.png"
          width={339}
          height={127}
          quality={90}
          alt="Pride 2025 brought to you in support of The Trevor Project"
        />
      </ImageWrapper>
      <TextWrapper>
        <DisclaimerText>
          From Sunday June 1st 12pm ET to Monday June 30th 12pm ET (30 days), $1,000 will be donated per day (for a
          total of $30,000) to The Trevor Project. Additionally, for every purchase of the 2025 Pride Pin Set made
          online at{' '}
          <StyledLink.Primary onClick={() => posthog.capture('pride2025_pdp_makeshipLink', { modalLocation })} href="/">
            makeship.com
          </StyledLink.Primary>
          , Makeship will also donate 50% of retail sales to The Trevor Project. The Trevor Project is a United States
          501(c)(3) public charity whose mission is to end suicide among gay, lesbian, bisexual, transgender, queer, and
          questioning (LGBTQ+) young people. To learn more about The Trevor Project, visit{' '}
          <StyledLink.Primary
            onClick={() => posthog.capture('pride2025_pdp_trevorProjectLink', { modalLocation })}
            href="https://www.thetrevorproject.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.thetrevorproject.org
          </StyledLink.Primary>
          . No portion of purchase is tax deductible. Makeship will receive no remuneration for conducting this
          campaign.
        </DisclaimerText>
      </TextWrapper>
    </DisclaimerWrapper>
  );
};

export default Pride2025Disclaimer;
